import { FIELD_TYPES } from '../../components/FormField'

export const FIELDS = [
  { label: 'Name', name: 'name', type: FIELD_TYPES.TEXT, defaultValue: '' },
  {
    label: 'Description',
    name: 'description',
    type: FIELD_TYPES.TEXT,
    defaultValue: '',
  },
  {
    label: 'Type',
    name: 'type',
    type: FIELD_TYPES.SELECT,
    options: [
      { label: 'Feature', value: 'feature' },
      { label: 'Agency', value: 'agency' },
    ],
    defaultValue: 'feature',
  },
]
